<template>
  <el-dialog
    :visible.sync="isShow"
    title="填写账期"
    width="600px"
    @close="closeDialog"
  >
    <div>
      <el-descriptions
        :column="3"
        border
      >
        <el-descriptions-item label="账期">
          <div v-for="(item, index) in AccountPeriod" :key="index" class="box-border">
            <span>
              账期
              <el-input v-model="item.days" placeholder="请输入天数" style="width: 100px;" @input="onInput($event, index, 'days')" />
              天
            </span>&nbsp;&nbsp;&nbsp;
            <span>
              比例
              <el-input v-model="item.proportion" placeholder="请输入比例" style="width: 100px;" @input="onInput($event, index, 'proportion')" />
              %
            </span>
            <span class="box-bottom">
              <span @click="AddBtn">添加</span>
              <span v-if="index !== 0" @click="deleteBtn(index)">删除</span>
            </span>
          </div>
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" @click="submitData">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>

export default {
  data () {
    return {
      isShow: false,
      AccountPeriod: [
        {
          days: '',
          proportion: ''
        }
      ]
    };
  },

  methods: {
    openDialog (value) {
      if (value) {
        const parts = value.split('/').map(item => {
          const [days, proportionWithPercentage] = item.split(',');
          const proportion = proportionWithPercentage.replace('%', ''); // 去除百分号
          return { days, proportion };
        });
        this.AccountPeriod = parts;
      } else {
        this.AccountPeriod = [{
          days: '',
          proportion: ''
        }];
      }
      this.isShow = true;
    },

    closeDialog () {
      this.isShow = false;
      this.AccountPeriod = [
        {
          days: '',
          proportion: ''
        }
      ];
    },
    onInput (event, index, name) {
      let input = event;
      // 使用正则表达式确保只有数字被输入
      input = input.replace(/\D/g, ''); // 只保留数字
      if (name === 'days' && input.length > 1 && input[0] === '0') {
        input = input.substring(1);
      }
      if (name === 'proportion' && input.length >= 1 && input[0] === '0') {
        input = input.substring(1);
      }
      this.AccountPeriod[index][name] = input;
    },
    submitData () {
      for (const subFile of this.AccountPeriod) {
        if (!subFile.days || !subFile.proportion) {
          this.$message.warning('账期/比例不能为空');
          return;
        }
      }
      for (let i = 1; i < this.AccountPeriod.length; i++) {
        if (parseInt(this.AccountPeriod[i].days) <= parseInt(this.AccountPeriod[i - 1].days)) {
          this.$message.warning('账期天数应逐条递增');
          return;
        }
      }
      let num = 0;
      for (const subFile of this.AccountPeriod) {
        num = parseInt(num) + parseInt(subFile.proportion);
      }
      if (parseInt(num) !== 100) {
        this.$message.warning('比例之和应为100%');
        return;
      }
      const resultString = this.AccountPeriod.map(item => `${item.days},${item.proportion}%`).join('/');
      this.isShow = false;
      this.$emit('childEvent', resultString);
      this.AccountPeriod = [
        {
          days: '',
          proportion: ''
        }
      ];
    },
    AddBtn () {
      this.AccountPeriod.push({
        days: '',
        proportion: ''
      });
    },
    deleteBtn (index) {
      this.AccountPeriod.splice(index, 1);
    }
  }
};
</script>

<style scoped lang="scss">
.reason-wrap ::v-deep .el-form-item__content{
  margin-left: 0 !important;
}
:deep(.el-descriptions-item__label){
  width: 100px !important;
}
:deep(.el-descriptions-item__content){
  padding: 0 !important;
}
.box-border{
  border-bottom: 1px solid #EBEEF5;
  padding: 10px 15px;
}
.box-border:nth-last-child(1){
  border-bottom: 0 !important;
}
.box-bottom{
  span{
    color: rgba(37, 137, 255, 1);
    margin-left: 15px;
    cursor: pointer;
  }
}
:deep(.el-descriptions-item__label){
  color: #606266;
  text-align: right !important;
  padding-right: 20px !important;
}
:deep(.el-descriptions-item__label::before) {
  content: "* ";
  color: red;
}
:deep(.el-dialog__title){
  font-size: 16px !important;
}
:deep(.el-dialog__header){
  background-color: #fff;
  border-bottom: 1px solid #EBEEF5;
}
</style>
